import { render } from "./VUEFrameComponenteGraficoStorico.vue?vue&type=template&id=73892174"
import script from "./VUEFrameComponenteGraficoStorico.vue?vue&type=script&lang=js"
export * from "./VUEFrameComponenteGraficoStorico.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__